import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "navbar_logo" };
const _hoisted_2 = { href: "/" };
const _hoisted_3 = ["src"];
import { useStore } from '@/store/store';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const store = useStore();
        const src = ref(`assets/trade/logo_${store.getters.theme}.png`);
        watch(() => store.state.theme, () => {
            src.value = `assets/trade/logo_${store.getters.theme}.png`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", _hoisted_2, [
                    _createElementVNode("img", {
                        width: "189",
                        height: "63",
                        src: src.value
                    }, null, 8, _hoisted_3)
                ])
            ]));
        };
    }
});
